import { useQuery } from '@tanstack/react-query';

import accountsClient from '@clients/accountsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getAccountStatuses } = accountsClient();

const useGetAccountStatus = () => {
    const { data, error, isError, isLoading } = useQuery(
        ['getAccountStatuses'],
        () => getAccountStatuses(),
        {
            onError: notifyAPIError,
        },
    );

    return { data, error, isError, isLoading };
};

export default useGetAccountStatus;
